__turbopack_context__.v({
  "back-wrapper": "_6uf8Pa_back-wrapper",
  "center-wrap": "_6uf8Pa_center-wrap",
  "contentsContainer": "_6uf8Pa_contentsContainer",
  "headerContainer": "_6uf8Pa_headerContainer",
  "headerWrap": "_6uf8Pa_headerWrap",
  "is-account-page": "_6uf8Pa_is-account-page",
  "left-wrap": "_6uf8Pa_left-wrap",
  "mobile-nav-flex": "_6uf8Pa_mobile-nav-flex",
  "nav-open": "_6uf8Pa_nav-open",
  "navMobile": "_6uf8Pa_navMobile",
  "ribbon-container": "_6uf8Pa_ribbon-container",
  "right-wrap": "_6uf8Pa_right-wrap",
  "right-wrap-account": "_6uf8Pa_right-wrap-account",
  "second-level-active": "_6uf8Pa_second-level-active",
  "takequiz": "_6uf8Pa_takequiz",
  "textLink": "_6uf8Pa_textLink",
  "toggle-nav": "_6uf8Pa_toggle-nav",
  "toggler-wrap": "_6uf8Pa_toggler-wrap",
  "wrap": "_6uf8Pa_wrap",
});
